// core version + navigation, pagination modules:
import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

function swiperImageGallery() {
    
    // init Swiper:
    var init = false;

    // if (window.innerWidth >= 768) {
        if ( ! init ) {
            init = true;

            const swiper = new Swiper('.swiper-image-gallery', {

                modules: [Navigation, Autoplay, EffectFade],
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    },
                slidesPerView: 1,
                slidesPerGroup: 1,
                slidesPerColumn: 1,
                spaceBetween: 40,
                speed: 1000,
                breakpoints: {
                    // md
                    728: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        slidesPerColumn: 1,
                        spaceBetween: 40,
                    },
                },
            });
        }
    // } else if ( init ) {
    //     swiper.destroy();

    //     init = false;
    // }
}
swiperImageGallery();
window.addEventListener("resize", swiperImageGallery);

export default swiperImageGallery;